/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'

import { Card, message } from 'antd'
import './style.css'
import Modal from './modal'
import { parseTime } from '../../../util/index'
import { CLUB_ID } from '../../ClubBusiness/constants'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      record: {},
    }
  }

  showModal = (item) => {
    this.setState({ visible: true, record: item })
    this.props.fetchClubTableDetail({
      club_id: sessionStorage.getItem(CLUB_ID),
      table_id: item.table_id,
    }) //详情
  }
  handleOk = (e) => {
    this.setState({ visible: false })
  }

  handleCancel = (e) => {
    this.setState({ visible: false, record: {} })
  }

  render() {
    const { tableList, tbDetail, billRecord, billRecordDetail } = this.props

    return (
      <div className="auth">
        {tableList &&
          tableList.map((item, idx) => {
            let currentTime = new Date()
            let startTime = parseTime(item.start_time)
            return (
              <Card
                key={idx}
                title={item.name}
                extra={
                  <div
                    style={{ color: '#108EE9', cursor: 'default' }}
                    onClick={() => this.showModal(item)}
                  >
                    查看详情
                  </div>
                }
                style={
                  startTime
                    ? {
                        width: '19%',
                        margin: '0 1% 1rem 0',
                        backgroundColor: 'rgba(16,142,233,0.5)',
                      }
                    : { width: '19%', margin: '0 1% 1rem 0' }
                }
              >
                <div className="auth-wallet">
                  <div>状态</div>
                  <div>{startTime ? '使用中...' : '空闲'}</div>
                </div>
                <div className="auth-wallet">
                  <div>开台时长</div>
                  <div>
                    {startTime
                      ? `开台${Math.round(
                          (currentTime - startTime) / 60000
                        )}分钟`
                      : '0分钟'}
                  </div>
                </div>
              </Card>
            )
          })}

        {this.state.visible && (
          <Modal
            {...this.state}
            tbDetail={tbDetail}
            billRecord={billRecord}
            billRecordDetail={billRecordDetail}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
            fetchClubSettlement={this.props.fetchClubSettlement}
            fetchBillRecordDetail={this.props.fetchBillRecordDetail}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/component/tableStatus.js